module.exports = __webpack_public_path__ + "img/registration-completed.043b83b6.svg";